import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import { Tags } from '../constants';
import MentionComponent from '../mentions';
import { MediaDefaultIcon } from '../../../icon';

interface IProps extends ICellRendererParams {
    Message: string,
}

export const MessageTagRenderer = (props: IProps) => {

    const TextMessage = (text: string) => {
        let shortMessage =!!text?text.slice(0):""
        let index = (shortMessage.lastIndexOf("{{") || shortMessage.lastIndexOf("{") || shortMessage.lastIndexOf("{{_"))
        let indexPosition = (index === 0 || index === -1) ? 0 : index
        let patternFirst = (shortMessage.match(/{{_/g) || []).length
        let patternLast = (shortMessage.match(/_}}/g) || []).length
        let string = shortMessage.slice(0, indexPosition)
        let stringIndex = indexPosition === 0 ? shortMessage : string
        let finalString = patternFirst !== patternLast ? stringIndex : shortMessage;
        return !!text ? finalString : "";
    };

    return (
        <div className='d-flex align-center'>
            <MentionComponent
                body={TextMessage(props.Message)}
                tags={Tags} 
                emoji={''}
                openTags={false}
                tagTarget={undefined}
                onChange={() => { }}
                onKeyDown={() => { }}
                closeTags={() => { }}
                maxLength={props.data?.Message?.length}
                id={''} placeholder={''}
                readOnly={true}
            />
            {!!props.data.Media && <div>
                <MediaDefaultIcon className={"ml-1"} />
            </div>
            }
        </div>
    );
};
